/**
 * state mặc định của module
 */
export default {
	stickInfo(state, res) {
		state.Stick = res.Sticks;
	},
	addStickItem(state, res) {
		if (state.Stick) {
			// mode = true: là thêm, false là sửa
			let mode = true;
			if (state.Stick && state.Stick.length > 0) {
				let stickIndex = state.Stick.findIndex(item => {
					return item.StickId == res.StickId;
				});
				// Sửa lại
				if (stickIndex >= 0) {
					state.Stick[stickIndex].StickName = res.StickName;
					state.Stick[stickIndex].StickColor = res.StickColor;
					mode = false;
				}
			}

			// Thêm vào
			if (mode) {
				if (!state.Stick) {
					state.Stick = [];
				}
				state.Stick.unshift(res);
			}
		}
	},
	removeStickItem(state, res) {
		if (state.Stick && state.Stick.length > 0) {
			let stickIndex = state.Stick.findIndex(item => {
				return item.StickId == res;
			});
			// Xóa stick cần xóa khỏi local storage
			if (stickIndex >= 0) {
				state.Stick.splice(stickIndex, 1);
			}
		}
	}
};
